import { Mail, MapPin, MoreHorizontal, Phone, User } from "lucide-react";
import { Button } from "../ui/button";
import { Card } from "../ui/card";
import { Separator } from "../ui/separator";

export function AgentDetailsCard({ selectedApplicationData, ...props }) {
  return (
    <Card className="p-5 bg-white shadow-sm" {...props}>
      <div className="flex justify-between items-start mb-4">
        <h3 className="text-base font-semibold flex items-center">
          <User className="h-4 w-4 mr-2 text-[#FF5533]" />
          Agent Details
        </h3>
        {/* <Button variant='ghost' size='sm' className='h-8 w-8 p-0 px-0'>
          <MoreHorizontal className='h-4 w-4' />
        </Button> */}
      </div>

      <div className="space-y-4">
        <div className="flex items-start gap-3">
          <div className="w-10 h-10 rounded-full bg-[#FFF0ED] flex items-center justify-center flex-shrink-0">
            <User className="h-5 w-5 text-[#FF5533]" />
          </div>
          <div>
            <h4 className="font-medium">
              {selectedApplicationData.agent_name}
            </h4>
            <p className=" text-gray-500">Insurance Agent</p>
          </div>
        </div>

        <Separator />

        <div className="space-y-3 ">
          <div className="flex items-center gap-2">
            <Phone className="h-4 w-4 text-gray-400 flex-shrink-0" />
            <span>{selectedApplicationData.agent_phone || "---"}</span>
          </div>
          <div className="flex items-center gap-2">
            <Mail className="h-4 w-4 text-gray-400 flex-shrink-0" />
            <span className="truncate">
              {selectedApplicationData.agent_email || "---"}
            </span>
          </div>
          <div className="flex items-start gap-2">
            <MapPin className="h-4 w-4 text-gray-400 flex-shrink-0 mt-0.5" />
            {selectedApplicationData.agent_address || "---"}
          </div>
        </div>

        <Separator />

        <div>
          <h4 className=" font-medium mb-2">Agent Information</h4>
          <div className="grid grid-cols-2 gap-x-4 gap-y-2 ">
            <div>
              <p className="text-sm text-gray-500">Agent ID:</p>
              <p>---</p>
            </div>
            <div>
              <p className="text-sm text-gray-500">License #:</p>
              <p>---</p>
            </div>
            <div>
              <p className="text-sm text-gray-500">Years with Client:</p>
              <p>---</p>
            </div>
            <div>
              <p className="text-sm text-gray-500">Last Contact:</p>
              <p>---</p>
            </div>
          </div>
        </div>
      </div>
    </Card>
  );
}
